import styles from "./styles.module.css"
import { useEffect, useState } from "react"

export default function InputFileImageChangeBgColor({ value, setValue, bookData, bgColor }) {

    const [background, setBackground] = useState(bookData ? bookData.image ? bookData.image : 'https://i.pinimg.com/736x/28/03/4e/28034e601b054650d3a70e382db80b44.jpg' : 'https://i.pinimg.com/736x/28/03/4e/28034e601b054650d3a70e382db80b44.jpg');

    let changeBackground = (value) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setBackground(reader.result)
            }
        }
        reader.readAsDataURL(value);
    }



    return (
        <div className={styles.inputFileImage} >
            <label style={{ backgroundColor: bgColor, backgroundImage: "url('" + background + "')" }} htmlFor="background">
                <input onChange={(event) => { setValue(event.target.files[0]); changeBackground(event.target.files[0]); }} accept="image/*" name="background" type="file"></input>
            </label>
        </div>
    );
}